


















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { dateFormat } from '@/helpers/dateFormat';

@Component
export default class UiDatePicker extends Vue {
  @Prop({
    default: '',
  })
  public label!: string;
  @Prop(String)
  public value!: string;
  @Prop({
    default: null,
  })
  public min?: string;
  @Prop({
    default: null,
  })
  public max?: string;
  @Prop({
    default: '',
  })
  public suffix?: string;
  @Prop({
    default: '',
  })
  public placeholder?: string;
  @Prop({
    default: '',
  })
  public height?: string;
  @Prop({
    default: false,
  })
  public singleLine?: boolean;
  @Prop({
    default: false,
  })
  public outline?: boolean;
  @Prop({
    default: false,
  })
  public hideDetails?: boolean;
  @Prop({
    default: false,
  })
  public required?: boolean;
  @Prop({
    default: () => [],
  })
  public rules?: any[];
  @Prop({
    default: false,
  })
  public clearable?: boolean;
  @Prop({
    default: false,
  })
  public loading?: boolean;
  @Prop({
    default: false,
  })
  public disabled?: boolean;
  @Prop({
    default: false,
  })
  public readonly?: boolean;

  @Prop({
    default: null,
  })
  public hint?: string;

  @Prop({
    default: false,
  })
  public persistentHint?: boolean;

  @Prop()
  public functionEventsColors: any;

  private dateMenu: boolean = false;

  private dateFormatted: any = null;
  private date: any = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('value')
  public onChangeValue(val: string): void {
    this.date = val;
    this.dateFormatted = this.formatDate(val);
    this.dateMenu = false;
  }

  public beforeMount(): void {
    this.onChangeValue(this.value);
  }

  public onChangeDateFormatted(): void {
    this.date = dateFormat(this.dateFormatted, 'US', 'DD/MM/YYYY', true);
    this.onChange();
  }

  public handleClear(): void {
    this.$emit('input', null);
    this.$emit('change', null);
  }

  public onChange(): void {
    this.$emit('input', this.date);
    this.$emit('change', this.date);
  }

  private formatDate(date: string): string {
    return !date ? '' : dateFormat(date, 'BR', undefined, true);
  }

  public focus() {
    setTimeout(() => {
      this.$refs['tfDate'].focus();
      this.dateMenu = true;
    }, 300);
  }
}
